// Shopify
import createApp from '@shopify/app-bridge';
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        initialised: false,
        shop: '',
        token: '',
		host: '',
        billing: false,
		beta_tester: '',
		created: null,
		version: null,
    },
    mutations: {
		setApp: function (state, app)  {
			Vue.set(state, 'app', app)
			
		},
        setInitialised: function (state, payload) {
            state.initialised = payload.initialised
		},
		setCredentials: function (state, payload) {
			state.shop       = payload.shop
			state.host       = payload.host
			state.token      = payload.token
			state.beta_tester = payload.beta_tester
			state.created = payload.created
			state.version = payload.version
			localStorage.setItem('token', payload.token)
		},
    },
	getters: {
		app: state => {
			return state.app
		},
		token: state => state.token || localStorage.getItem('token'),
		shop: state => state.shop,
		host: state => state.host,
		beta_tester: state => state.beta_tester || '',
		created: state => state.created,
		
	},
    actions: {
		initAppBridge: async function({ state, commit, dispatch }, hostFromRoute?: string) {
			let host = hostFromRoute || null
			if (!host && typeof window !== 'undefined') {
		      host = sessionStorage.getItem('shopifyHost')
    		}
			const apiKey = process.env.VUE_APP_SHOPIFY_APP_KEY || ''
			try{ 
				const app = await createApp({
					apiKey: apiKey,
					host: hostFromRoute || host || '',
					forceRedirect: true
				})
				commit('setApp', app)
			} catch(e) {}
			if(window.top !== window.self){
				commit('setInitialised', {initialised: true})
			}
			return state.app
		},

    },
    modules: {
    }
}
